/**
 * returns a function that accept some custom info
 * and returns the interceptor object.
 * intent to be injected and use in DAO's
 *
 * @returns {Function}
 */
export function xrayUINotificationsInterceptor($q, JFrogNotifications) {

    /**
     * accept an additional info that can be used
     * in the returned interceptor object
     *
     * @returns {{response: Function, responseError: Function}}
     */
    return {
        response: function (res) {
            if (res.data && (res.data.info || res.data.error) && !(res.config && res.config.params && res.config.params.$suppress_toaster)) {
                if (res.data.info) {
                    JFrogNotifications.create({info: res.data.info});
                }
                else if (res.data.error) {

                    if (res.data.error.indexOf('errors') > -1 && !res.data.error.indexOf('analysis')) {
                        let data = JSON.parse(res.data.error);
                        JFrogNotifications.create({error: 'Error: ' + data.errors[0].message}, true);
                    }
                    else {
                        JFrogNotifications.create({error: res.data.error}, true);
                    }

                }
            }
            else if (_.includes([200, 201], res.status) && _.includes(['PUT', 'POST', 'DELETE'], res.config.method) && !(res.config && res.config.params && res.config.params.$suppress_toaster)) {
                JFrogNotifications.create({info: 'The operation was successful'});
            }
            return res;
        },
        responseError: function (res) {
            // Response error as single object:
            if (res.data && (res.data.error || res.data.warn) && !(res.config && res.config.params && res.config.params.$suppress_toaster)) {
                JFrogNotifications.create(res.data);
            }
            else if (res.status === 409 && !(res.config && res.config.params && res.config.params.$suppress_toaster)) {
                JFrogNotifications.create({error: '409 Conflict'});
            }
            else if (res.status >= 500 && _.includes(['PUT', 'POST', 'DELETE'], res.config.method) && !(res.config && res.config.params && res.config.params.$suppress_toaster)) {
                JFrogNotifications.create({error: 'Server error'});
            }
            return $q.reject(res);
        }
    }
}



// WEBPACK FOOTER //
// ./modules/xray/data/xray-ui_notifications_interceptor.js